import React, { useEffect, useState } from "react";
import "./sessionTicket.css";
import TransactionError from "../TransactionError/TransactionError";
import { useLocation } from "react-router-dom";
import Error404 from "../404Error/404Error";

const SessionTicket = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [ticketData, setTicketData] = useState(null);
  const [noToken, setNoToken] = useState(false);
  const [transactionError, setTransactionError] = useState(false);

  const fetchTicketData = async () => {
    const access_token = searchParams.get("token");
    const booking_id = searchParams.get("booking_id");

    if (!access_token) {
      setNoToken(true);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}transaction/everest/v1/transaction-detail?booking_id=${booking_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );

      const data = await response.json();

      if (data?.meta?.status_code === 4000) {
        setNoToken(true);
        return;
      }
      if (!data?.data?.transaction_id) {
        setTransactionError(true);
        return;
      }
      setTicketData(data);
    } catch (err) {
      console.log("Error Getting Data", err);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("cameFromSessionTicket", "true");
    fetchTicketData();
  }, []);

  if (noToken) {
    return <Error404 />;
  }

  if (
    ticketData?.meta?.status_code === 2001 ||
    ticketData?.meta?.status_code === 3001
  ) {
    return <TransactionError />;
  }

  if (transactionError) {
    return <TransactionError />;
  }

  return (
    <>
      {ticketData?.data?.transaction_id && (
        <div className="ticketConatiner">
          <h2 className="header">Session Details</h2>

          <div className="container">
            <div className="ticket">
              {/* Ticket Cutout */}
              <div className="cutout left top"></div>
              <div className="cutout left bottom"></div>
              <div className="cutout right top"></div>
              <div className="cutout right bottom"></div>

              {/* Ticket Content */}
              <div className="booking-id">
                <p>Booking ID</p>
                <p className="bold">{ticketData?.data?.transaction_id}</p>
              </div>

              <div className="details">
                <div className="row">
                  <p className="chargerName">Charger Name</p>
                  <p className="chargerName">Connector</p>
                </div>
                <div className="row">
                  <p className="label">{ticketData?.data?.charger_name}</p>
                  <p className="label">{ticketData?.data?.connector_name}</p>
                </div>

                <div className="row">
                  <p className="chargerName">Vehicle Details</p>
                  <p className="chargerName">SOC Details</p>
                </div>
                <div className="row">
                  <p className="label">{ticketData?.data?.vehicle}</p>
                  <p className="label">
                    Start: {ticketData?.data?.start_soc} <br /> End:{" "}
                    {ticketData?.data?.current_soc}
                  </p>
                </div>
              </div>

              <hr className="divider" />

              <div className="details">
                <div className="row">
                  <p className="chargerName" style={{ fontSize: "12px" }}>
                    Units
                  </p>
                  <p className="label">{ticketData?.data?.units}</p>
                </div>
                <div className="row">
                  <p className="chargerName" style={{ fontSize: "12px" }}>
                    Start Time
                  </p>
                  <p className="label">{ticketData?.data?.start_time}</p>
                </div>
                <div className="row">
                  <p className="chargerName" style={{ fontSize: "12px" }}>
                    Stop Time
                  </p>
                  <p className="label">{ticketData?.data?.end_time}</p>
                </div>
              </div>

              <hr className="divider" />

              <div className="station-container">
                <p className="station-name">{ticketData?.data?.station_name}</p>
                <p className="station-address">
                  {ticketData?.data?.station_address}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SessionTicket;
